const routes = [
  {
    path: '/attachments/:page?',
    props: true,
    component: () => import('@/views/base/attachment/AttachmentsList.vue')
  },
  {
    path: '/attachment/:attachmentId/:nav?/:page?',
    props: true,
    component: () => import('@/views/base/attachment/AttachmentDetails.vue')
  }
]

export default routes
